<template>
  <!--
    LocaleSwitcher 컴포넌트
    REQ-LOCALE-FE-005/009: 中文/한국어 2 옵션만 노출 + applyLocale dispatch
    REQ-LOCALE-FE-008: 단일 진입점 (locale/applyLocale)
    R-9: defineProps에 class/style 정의 금지 → fallthrough attribute 보장
    SPEC: SPEC-CHINA-ADMIN-LOCALE-CORE-001
  -->
  <a-select
    :value="currentLocale"
    :aria-label="t('locale.switch_language')"
    @change="onLocaleChange"
    style="width: 100px;"
  >
    <a-select-option value="zh">{{ t('locale.chinese') }}</a-select-option>
    <a-select-option value="ko">{{ t('locale.korean') }}</a-select-option>
  </a-select>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

export default {
  name: 'LocaleSwitcher',
  // R-9 회피: props에 class/style 정의 금지 (Vue 3 fallthrough attribute 활용)
  setup() {
    const store = useStore();
    const { t } = useI18n();

    // 현재 locale (Vuex state에서)
    const currentLocale = computed(() => store.state.locale.locale);

    /**
     * locale 변경 핸들러
     * @param {string} value - 'ko' | 'zh'
     */
    /**
     * FE-D2 patch: dispatch await + 비-AbortError 실패 시 toast 표시
     * REQ-LOCALE-FE-005/006/008: 단일 진입점, PATCH 실패 toast, AbortError 예외
     */
    const onLocaleChange = async (value) => {
      try {
        await store.dispatch('locale/applyLocale', {
          source: 'dropdown',
          value,
        });
      } catch (e) {
        // AbortError(cancel-and-replace)는 toast 0건 (REQ-LOCALE-FE-006 단서)
        if (e?.name === 'AbortError' || e?.code === 'ERR_CANCELED') return;
        // 비-AbortError: toast 노출 (ant-design-vue message)
        const { message } = await import('ant-design-vue');
        message.error(t('locale.save_failed') || '语言保存失败 / 언어 저장 실패');
        // i18n/localStorage/state는 이미 낙관적으로 반영됨 — 사용자가 다시 시도 가능
      }
    };

    return {
      currentLocale,
      onLocaleChange,
      t,
    };
  },
};
</script>
